import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ScipTableFilterService } from './scip-table-filter.service';
import { translationKeys } from '../../../../core';

@Component({
  selector: 'scip-table-filter-reset-all',
  templateUrl: './scip-table-filter-reset-all.component.html'
})
export class ScipTableFilterResetAllComponent {
  @Input() parentTableIdentifier: string;

  @Output() readonly filterReset = new EventEmitter<boolean>();

  translationKeys: typeof translationKeys = translationKeys;

  constructor(private scipTableFilterService: ScipTableFilterService) {}

  @HostListener('click', ['$event'])
  private handleClick() {
    this.scipTableFilterService.clearAllFilters(this.parentTableIdentifier);
    this.filterReset.emit(true);
  }
}
